Ext.define('SA.view.pvt.ViewActionsButton', {
    alias: 'widget.pvt-view-actions-button',
    extend: 'SA.view.MenuButton',

    text: 'View Actions',

    initComponent() {
        this.callParent();

        this.menu = {xtype: 'menu', items: []};
        this.editItem = {text: 'Edit View', handler: () => this.onEditItemClick()};
        this.deleteItem = {text: 'Delete View', handler: () => this.onDeleteItemClick()};
    },

    add(item) {
        item.projectView = this.projectView;

        this.menu.items.push(item);

        return this;
    },

    addGroup(items) {
        this.ensureSeparator();

        Ext.Array.from(items).forEach(item => this.add(item));

        return this.addSeparator();
    },

    addDeleteItem() {
        return this.add(this.deleteItem);
    },

    addEditItem() {
        return this.add(this.editItem);
    },

    addSeparator() {
        return this.add({xtype: 'menuseparator'});
    },

    ensureSeparator() {
        var lastItem = SA.Array.getLast(this.menu.items);

        if (lastItem && lastItem.xtype !== 'menuseparator') {
            this.addSeparator();
        }
    },

    onDeleteItemClick() {
        SA.AppController.deleteView(this.projectView);
    },

    onEditItemClick() {
        SA.AppController.showProjectView(this.projectView, 'edit');
    },

    setProjectView(projectView) {
        this.projectView = projectView;

        return this;
    }
});